import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const LoaderOutlinedSize24Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.8C10.1804 2.8 8.40169 3.33957 6.88876 4.35048C5.37583 5.36139 4.19664 6.79823 3.50031 8.47931C2.80399 10.1604 2.6218 12.0102 2.97678 13.7948C3.33176 15.5795 4.20798 17.2187 5.49462 18.5054C6.78126 19.792 8.42055 20.6682 10.2052 21.0232C11.9898 21.3782 13.8396 21.196 15.5207 20.4997C17.2018 19.8034 18.6386 18.6242 19.6495 17.1112C20.6604 15.5983 21.2 13.8196 21.2 12H23C23 14.1756 22.3549 16.3023 21.1462 18.1113C19.9375 19.9202 18.2195 21.3301 16.2095 22.1627C14.1995 22.9952 11.9878 23.2131 9.85401 22.7886C7.72022 22.3642 5.76021 21.3165 4.22183 19.7782C2.68345 18.2398 1.6358 16.2798 1.21137 14.146C0.786929 12.0122 1.00477 9.80047 1.83733 7.79048C2.66989 5.78049 4.07979 4.06253 5.88873 2.85383C7.69767 1.64514 9.82441 1 12 1V2.8Z"
                fill="var(--magritte-ui-icon-color)"
            />
        </g>
    </svg>
);
const LoaderOutlinedSize24 = hoc<'LoaderOutlinedSize24'>(
    forwardRef(LoaderOutlinedSize24Component),
    'LoaderOutlinedSize24'
);
export default LoaderOutlinedSize24;
